// Napflix OS runtime shell v1
// Explicit kiosk/Pi runtime behavior. Normal browser sessions stay untouched.
export function isNapflixOSMode() {
  if (typeof window === "undefined") return false;

  return new URLSearchParams(window.location.search).get("kiosk") === "napflix";
}

const isEditableTarget = (target) =>
  !!target?.closest?.("input, textarea, select, [contenteditable='true']");

export function installNapflixOSRuntimeShell() {
  if (typeof window === "undefined" || !isNapflixOSMode()) {
    return () => {};
  }

  const root = document.documentElement;
  const cursorStyle = document.createElement("style");
  let cursorTimer = null;

  const showCursor = () => {
    root.classList.remove("napflix-os-cursor-idle");
    window.clearTimeout(cursorTimer);
    cursorTimer = window.setTimeout(() => {
      root.classList.add("napflix-os-cursor-idle");
    }, 2200);
  };

  const preventContextMenu = (event) => {
    event.preventDefault();
  };

  const preventAccidentalDragSelect = (event) => {
    if (isEditableTarget(event.target)) return;
    event.preventDefault();
  };

  root.classList.add("napflix-os");
  cursorStyle.textContent = `
    html.napflix-os.napflix-os-cursor-idle,
    html.napflix-os.napflix-os-cursor-idle * {
      cursor: none !important;
    }
  `;
  document.head.appendChild(cursorStyle);

  window.addEventListener("mousemove", showCursor, { passive: true });
  window.addEventListener("mousedown", showCursor, { passive: true });
  window.addEventListener("keydown", showCursor);
  window.addEventListener("touchstart", showCursor, { passive: true });
  window.addEventListener("contextmenu", preventContextMenu);
  window.addEventListener("dragstart", preventAccidentalDragSelect);
  window.addEventListener("selectstart", preventAccidentalDragSelect);
  showCursor();

  return () => {
    window.clearTimeout(cursorTimer);
    window.removeEventListener("mousemove", showCursor);
    window.removeEventListener("mousedown", showCursor);
    window.removeEventListener("keydown", showCursor);
    window.removeEventListener("touchstart", showCursor);
    window.removeEventListener("contextmenu", preventContextMenu);
    window.removeEventListener("dragstart", preventAccidentalDragSelect);
    window.removeEventListener("selectstart", preventAccidentalDragSelect);
    cursorStyle.remove();
    root.classList.remove("napflix-os", "napflix-os-cursor-idle");
  };
}
